import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    templateUrl: './perform-action-pending.modal.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PerformActionPendingModal{

  @Input() displayMessage!: string;
  
}
